import { action, observable, makeObservable } from 'mobx';

import { apiCaller } from '@services/apiCaller';
import { IRootStore } from '@stores/index';
import { ApiAccountDefinition } from '@api';
import { getApiErrorMessage } from '@components/common/util/util';

export interface IAccountDefinitionsListStore {
  accountDefinitions: ApiAccountDefinition[];
  firstLoad: boolean;
  loadFailed: boolean;
  getAccountDefinitions(): Promise<void>;
}

export class AccountDefinitionsListStore implements IAccountDefinitionsListStore {
  @observable public accountDefinitions: ApiAccountDefinition[] = [];

  @observable public firstLoad = false;

  /**
   * Whether the last load attempt failed. `firstLoad` alone cannot express this: it
   * is only set on success, so a failure is indistinguishable from a load still in
   * flight. Consumers gating on `!firstLoad` would otherwise wait forever — this is
   * fetched once per session, with no retry.
   */
  @observable public loadFailed = false;

  @observable public rootStore: IRootStore;

  constructor(rootStore: IRootStore) {
    makeObservable(this);
    this.rootStore = rootStore;
  }

  @action.bound
  public async getAccountDefinitions() {
    this.loadFailed = false;
    try {
      const res = await apiCaller().get<{ data: ApiAccountDefinition[] }>(
        '/web/account-definitions',
      );
      this.accountDefinitions = res.data.data;
      this.firstLoad = true;
    } catch (err) {
      this.loadFailed = true;
      this.rootStore.messagesStore.showErrorMessage(
        getApiErrorMessage(err, 'Failed to fetch account definitions'),
      );
    }
  }
}
